import Error from "components/Error"
import { useEffect, useState } from "react"
import { Form, Button, Col, FormGroup, Input, InputGroup, InputGroupAddon, InputGroupText, Modal, ModalBody, Row } from "reactstrap"
import { alert } from "components/Alert"
import { showLoading } from "components/Loading"
import { hideLoading } from "components/Loading"
import authService from "services/AuthService"

const initialData = { codigo: '', novaSenha: '' }

export default function AlterarSenha({ config, onClose }) {
  const [data, setData] = useState(initialData)
  const [errors, setErrors] = useState([])

  useEffect(() => {
    setData(initialData)
  }, [config])

  const validar = () => {
    const errors = []
    if (!data?.codigo) {
      errors.push({
        fieldName: 'codigo',
        error: 'Campo obrigatório'
      })
    } 
    if (!data?.novaSenha) {
      errors.push({
        fieldName: 'novaSenha',
        error: 'Campo obrigatório'
      })
    } 
    setErrors(errors)
    return errors.length === 0
  }

  const handleChange = (field, value) => {
    setData({ ...data, [field]: value })
  }

  const handleSubmit = async (ev) => {
    ev.preventDefault()

    if (validar()) {
      let res = null
      try {
        showLoading()
        res = await authService.resetarSenha(config.email, data.codigo, data.novaSenha)
        if (res.success) {
          alert({
            text: 'Sua senha foi alterada com sucesso!',
          })
          onClose && onClose()
        }
        hideLoading()
      } catch (ex) {
        hideLoading()
        alert({
          header: 'Atenção!',
          text: 'Código inválido'
        })
      }
    }
  }

  const handleCancelar = () => {
    onClose && onClose()
  }

  return (
    <Modal isOpen={!!config}>
      <ModalBody>
        <Form onSubmit={handleSubmit}>
          <p>Enviamos um código para o e-mail informado</p>
          <FormGroup>
            <InputGroup className="input-group-alternative">
              <InputGroupAddon addonType="prepend">
                <InputGroupText>
                  <i className="ni ni-lock-circle-open" />
                </InputGroupText>
              </InputGroupAddon>
              <Input
                placeholder="Código"
                type="text"
                autoComplete="codigo"
                value={data.codigo}
                onChange={e => handleChange('codigo', e.target.value)}
              />
            </InputGroup>
            <Error errors={errors} fieldName="codigo" className="mt-1" />
          </FormGroup>
          <FormGroup>
            <InputGroup className="input-group-alternative">
              <InputGroupAddon addonType="prepend">
                <InputGroupText>
                  <i className="ni ni-lock-circle-open" />
                </InputGroupText>
              </InputGroupAddon>
              <Input
                placeholder="Nova Senha"
                type="password"
                autoComplete="novaSenha"
                value={data.novaSenha}
                onChange={e => handleChange('novaSenha', e.target.value)}
              />
            </InputGroup>
            <Error errors={errors} fieldName="novaSenha" className="mt-1" />
          </FormGroup>
          <Row className="align-items-center">
            <Col>
              <Button className="my-2" outline color="primary" type="button" onClick={handleCancelar}>
                Cancelar
              </Button>
            </Col>
            <Col className="text-right">
              <Button className="my-2" color="primary" type="submit">
                Alterar a senha
              </Button>
            </Col>
          </Row>
        </Form>
      </ModalBody>
    </Modal>
  )
}